var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFbLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "700px",
    height: "700px",
    viewBox: "0 0 700 700",
    enableBackground: "new 0 0 700 700",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    width: 700,
    height: 700
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_2_)",
    fill: "#0866FF",
    d: "M600,350c0-138.071-111.929-250-250-250c-138.071,0-250,111.929-250,250 c0,117.245,80.715,215.622,189.606,242.638V426.396h-51.552V350h51.552v-32.919c0-85.092,38.508-124.532,122.048-124.532 c15.838,0,43.167,3.105,54.347,6.211v69.254c-5.901-0.621-16.149-0.932-28.882-0.932c-40.993,0-56.832,15.528-56.832,55.9V350 h81.659l-14.028,76.396h-67.631v171.772C504.073,583.218,600,477.818,600,350"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_2_)",
    fill: "#FFFFFF",
    d: "M447.918,426.396L461.946,350h-81.659v-27.019 c0-40.372,15.838-55.899,56.831-55.899c12.733,0,22.981,0.31,28.882,0.931V198.76c-11.18-3.106-38.509-6.212-54.347-6.212 c-83.539,0-122.048,39.441-122.048,124.533V350h-51.552v76.396h51.552v166.242C308.949,597.437,329.173,600,350,600 c10.254,0,20.358-0.632,30.288-1.831V426.396H447.918z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFbLogo);
export default __webpack_public_path__ + "static/media/fb-logo.cb7402f15ab4f27b85593c3bb6d9b937.svg";
export { ForwardRef as ReactComponent };